/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { filter, map, take } from "rxjs";
import { TenantGrant } from "../models/http/tenant/tenant-grant.model";
import { AuthorizationService } from "../services/authorization.service";
import { UserStateService } from "../services/state/user-state.service";
import { COMMON_TABS, PATHS } from "../utils/constants";

export const grantGuard: CanActivateFn = route => {
	const authorizationService = inject(AuthorizationService);
	const userStateService = inject(UserStateService);
	const router = inject(Router);
	const grant: TenantGrant = route.data["grant"];

	// Wait for user info, otherwise a hard refresh would evaluate empty grants.
	return userStateService.userInfo$.pipe(
		filter(userInfo => userInfo.id !== undefined && userInfo.id !== null),
		take(1),
		map(userInfo => {
			if (authorizationService.hasGrant(grant)) return true;

			const fallbackRoute = COMMON_TABS.filter(
				tab => !tab.requiresDcEnabled || userInfo.dcEnabled
			)
				.flatMap(tab => tab.pages)
				.find(page => authorizationService.hasGrant(`${page.pageName}:tab`))?.route;
			return fallbackRoute ? router.createUrlTree([PATHS.DASHBOARD, fallbackRoute]) : false;
		})
	);
};
